import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { AfterContentChecked, AfterViewChecked, Component, OnInit, ViewEncapsulation, NgZone } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Event as NavigationEvent, NavigationExtras, NavigationStart, Router } from '@angular/router';
import { SwPush, SwUpdate } from '@angular/service-worker';
import * as CryptoJS from 'crypto-js';
import * as Feather from 'feather-icons';
import * as Bowser from "bowser";
import { forkJoin, Subscription, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/shared/confirm-dialog/confirm-dialog.component';
import { $b } from '../libs/browser_utils.js';
import { EventBus } from '../libs/event_publisher.js';
import { DevicePermissionsComponent } from './common-features/device-permissions/device-permissions.component';
import { AppdataService } from './services/app-data/appdata.service';
import { ChatqueueService } from './services/chatqueue/chatqueue.service';
import { CommunicationInterfaceService } from './services/communicationInterface/communication-interface.service';
import { LivechatStartService } from './services/livechat-start/livechat-start.service';
import { MessengerService } from './services/messenger/messenger.service';
import { WebsocketService } from './services/websockets/websocket.service';

declare var window: any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit, AfterViewChecked, AfterContentChecked {
  configLoaded = false;
  configUrl = 'assets/app-config.json';
  labelUrl = 'assets/app-labels.json';
  isCaptchaLoaded = true;
  sessionStarted: boolean;
  eventBus: any = EventBus;
  intent: string = $b.GetQueryString('intent');
  ucid: string = $b.GetQueryString('ucid');
  queuePosition: any;
  who = '';
  connectedAgents = [];
  messages = [];
  headerLabel: any;
  legacy = false;
  isCaptchaEnabled: any;
  appConfig: any;
  parsedData: any;
  interactionID: any;
  encryptKey = 'ThisIsTheSecret';
  existingAgent: NavigationExtras;
  mySubscription: any;
  UserConnectednavigationExtras: NavigationExtras;
  colorCodes: any = ['#E74C3C', '#2980B9', '#1ABC9C', '#F39C12', '#2C3E50', '#FF5722', '#009688', '#E91E63', '#3F51B5'];
  progessBarStatus: boolean;
  subcriberInstance: Subscription;
  initialMsgIndex: any = 0;
  livechatStatus: any;
  showLiveChatStatus: any;
  queuePos = 0;
  sessionId: string;
  appLabels: any;
  defaultFirstAgentTheme: string;
  browserOptions = {};
  isBrowserValid: boolean;
  browserCheckEnabled: boolean = false;
  appVersion: string;
  constructor(
    private route: Router,
    private appDataService: AppdataService,
    private startService: LivechatStartService,
    private queueService: ChatqueueService,
    private websocketService: WebsocketService,
    private snackBar: MatSnackBar,
    public messengerService: MessengerService,
    private http: HttpClient,
    private dialog: MatDialog,
    private commInterface: CommunicationInterfaceService,
    private swpush: SwPush,
    private swupdate: SwUpdate,
    public zone: NgZone
  ) {
    console.log('%c AppComponent', 'color:white; background: blue;');
    this.subcriberInstance = this.messengerService.handleProgressBarObservable.subscribe((x) => {
      this.progessBarStatus = x;
    });
  }

  
  // loadConfig() {
  //   return this.http.get(this.configUrl).pipe(
  //     retry(3), // retry a failed request up to 3 times
  //     catchError(this.handleError) // then handle the error
  //   );
  // }

  /**
   * Method to get the configurations set at UI level, related to application  
   */
  loadConfig = forkJoin([
       this.http.get(this.configUrl).pipe(
      retry(3), // retry a failed request up to 3 times
      catchError(this.handleError) // then handle the error
    ),
    this.http.get(this.labelUrl).pipe(
      retry(3), // retry a failed request up to 3 times
      catchError(this.handleError) // then handle the error
    )
  ]);

  // to handle error
  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError('Something bad happened; please try again later.');
  }

  ngOnInit() {
    // load the app configuration
    this.loadConfig.subscribe((dt) => {
      
      this.configLoaded = true;
      console.log('Visual IVR Configurations :', dt);
      // update the private config
      this.appDataService.setConfig(dt[0]);
      // call open and see the session already exist
      this.appConfig = this.appDataService.getConfig();

      // if (Object.keys(this.appConfig).length === 0 && this.appConfig.constructor === Object) {
      //   this.decryptAppConfig();
      // }

      // adding theme class configured in app config to body as a part of theme impl
      this.appConfig?.theme !== '' ? document.body.classList.add(this.appConfig.theme) : document.body.classList.add('tetherfi');

      this.isCaptchaEnabled = this.appConfig.isCaptchaEnabled;
      this.startService.chatMode = this.appConfig.channelConfiguration.chatmode;
      this.showLiveChatStatus = this.appConfig.Realtime.LivechatLogs;
      this.defaultFirstAgentTheme = this.appConfig?.LivechatComponent?.defaultReceivedMsgAgentTheme;
      this.setAppVersion();
      if (this.appConfig?.websocket?.enabled) {
        console.debug('Websocket enabled - initalize websocket');
        this.websocketService.initalizeWebsocket(this.appConfig);
        this.websocketEvent();
      } else {
        console.debug('Livechat Comm interface enabled - open comm interface');
        this.commInterface.registerCallbackEvents();
        this.commInterface.receivedChatbotMsg();
        this.livechat2ReceivedMessages();
        this.commInterface.open();
        this.commInterface.logToServer('info', 'AppComponent.OnInit', 'Open');
      }

      // Pause and mute the audio playing from queue component
      this.commInterface.audio.pause();
      this.commInterface.audio.volume = 0;

      // to open device permission popup based on the config and if enabled, restrict the users in proceeding without
      //permission
      console.log('test', $b.GetLocalStorage('chatActive'));
      if(this.appConfig?.permissionsConfig?.enableRestriction && !$b.GetSessionStorage('sessionStarted')) {
        this.getDevicePermissions();
      }
      // load app labels
      this.appDataService.setLabels(dt[1]);
      this.appLabels = this.appDataService.getLabels();
      this.commInterface.checkDeviceSupport();
      if(this.appConfig?.browserSupport?.checkEnabled){
        this.browserCheckEnabled = this.appConfig?.browserSupport?.checkEnabled;
        this.browserOptions = this.appConfig?.browserSupport.browserOptions;
        this.checkBrowserSupport();
      }
      if(this.appConfig?.permissionsConfig?.enableAVcheck) {
        this.commInterface.getAudioVideoInputs();;
      }
    });

    

    /**
     * Subscribing for the livechat callback events and then handling different scenarios
     */
    this.commInterface.callbacksObservable.subscribe((callbackData) => {
      console.log('CallbackData', callbackData);
      // log to server
      this.commInterface.logToServer('info', 'AppComponent.Livechat.Callback', callbackData.callbackName);
      try {
        switch (callbackData.callbackName) {
          case 'OpenFailed':
            this.handleOpenFailed(callbackData.params);
            break;
          case 'OpenSuccess':
            this.handleOpenSuccess(callbackData.params);
            break;
          case 'StartSuccess':
            this.handleStartSuccess(callbackData.params);
            break;
          case 'StartFailed':
            this.handleStartFailed(callbackData.params);
            break;
          case 'RemoteUserConnected':
            // tslint:disable-next-line: max-line-length
            this.handleRemoteUserConnected(
              callbackData.params.name,
              callbackData.params.agentId,
              callbackData.params.sessionID,
              callbackData.params.extraParam
            );
            break;
          case 'MessageReceived':
            this.handleMessageReceivedEvent(callbackData.params.agent, callbackData.params.message, callbackData.params.id);
            break;
          case 'ConferenceUserLeft':
            this.handleConferenceUserLeft(callbackData.params.agent, callbackData.params.message);
            break;
          case 'CallbackAutoRegistered':
            this.handleCallbackAutoRegistered(callbackData.params);
            break;
          case 'TypingStateChanged':
            this.handleTypingStateChanged(callbackData.params.agent, callbackData.params.state);
            break;
          case 'AppMessageEvent':
            this.handleAppMessageEvent(callbackData.params.agent, callbackData.params.message, callbackData.params.id);
            break;
          case 'InternalServerError':
            this.handleInternalServerError(callbackData.params);
            break;
          case 'CallQueued':
            this.handleCallQueued(callbackData.params.queuePos, callbackData.params.queueType);
            break;
          case 'ServerStateChanged':
            this.handleServerStateChanged();
            break;
          case 'ServersideEnd':
            this.handleOnEnd(callbackData.params.initiator, callbackData.params.reason);
            break;
          case 'ClientsreasoneEnd':
            this.handleOnEnd(callbackData.params.initiator, callbackData.params.reason);
            break;
          case 'End':
            this.handleOnEnd(callbackData.params.initiator, callbackData.params.reason);
            break;
        }
      } catch (error) {
        console.error('Exception in AppComponent.commInterface.callbacksObservable', error);
      }
    });
    
    this.checkForUpdate();
    if ('serviceWorker' in navigator) {
      this.messengerService.subscribeToNotification();
    }

    /**
     * Checking for update using swUpdate
     */
    this.swupdate.available.subscribe((event) => {
      console.log('New update available');
      this.updateToLatest();
    });

    /**
     * Trigger on received notification
     */
    this.swpush.notificationClicks.subscribe((event) => {
      console.log('Received notification: ', event);
      const url = event.notification.data.url;
      window.open(url, '_blank');
    });    
  }

  ngAfterViewChecked() {
    Feather.replace();
  }

  ngAfterContentChecked() {
    /**
     * Check the route and then show logs for livechat sdk events in the bottom.
     * Disabled for chat page
     */
     this.zone.run(() => {
        this.route.events.subscribe((event: NavigationEvent) => {
          if (event instanceof NavigationStart) {
            if (event.url.includes('chat')) {
              this.showLiveChatStatus = false;
            } else {
              this.showLiveChatStatus = this.appConfig?.Realtime?.LivechatLogs;
            }
          }
        });
      });
  }

  /**
   * Decrypt the app-config fetched from localstorage
   */
  decryptAppConfig() {
    const decryptData = CryptoJS.AES.decrypt($b.GetLocalStorage('appconfig'), this.encryptKey);
    const obj = JSON.parse(decryptData.toString(CryptoJS.enc.Utf8));
    this.appConfig = obj;
  }

  /**
   * Custom logger method
   * @param type : Logger type
   * @param method : Method Name
   * @param log : Log Message
   * @param show : Show logger or not
   */
  log(type: string, method: string, log: string, show: boolean) {
    if (show === true) {
      console.log(new Date() + ' -' + type + ' -', method + ' -', log);
    }
  }

  /**
   * Method to handle handleOpenSuccess - overriden by Livechat SDK method
   * @param session : Session related data received from livechat if OpenSuccess
   */
  handleOpenSuccess = (session: any) => {
    // console.log('%c handleOpenSuccess: ' + session, 'color: cyan');
    try {
      this.messengerService.LivechatStatus = 'OpenSuccess';
      this.livechatStatus = this.messengerService.LivechatStatus;
      if(($b.GetLocalStorage('chatActive') === null || $b.GetLocalStorage('chatActive') == 'false') || ($b.GetSessionStorage('Initial Load') && $b.GetLocalStorage('chatActive') == 'true'))
      {
        if (session.trans && session.trans.length > 0) {
          session.trans.forEach((element) => {
            if (element.type === 'connect') {
              this.handleRemoteUserConnected(element.name, element.id, session.sid_webapi, null);
            } else if (element.type === 'disconnect') {
              this.handleConferenceUserLeft(element.id, '');
            } else {
              if (this.who === '' || this.who === 'bot') {
                // according to chatbot impl we need customer selected detail to be displayed 
                if (element.by !== 'c' || (this.appConfig?.chatBot?.enabled)) {
                  const msg = decodeURIComponent(element.msg);
                  this.handleMessageReceivedEvent(element.by, msg, '');
                }
              } else {
                const msg = decodeURIComponent(element.msg);
                this.handleMessageReceivedEvent(element.by, msg, '');
              }
            }
          });
        } else {
          this.snackBar.open(`No session available.`, '', {
            duration: 3000,
            horizontalPosition: 'center',
            verticalPosition: 'bottom',
            panelClass: ['mat-toolbar']
          });
          this.commInterface.end('No Session Available', '');
        }
      }      

      // assign the session id
      this.sessionId = session?.sid_tchat?.split('_')?.[1] ?? '';
    } catch (error) {
      console.error('%c Error Occured in handleOpenSuccess - ', 'color: red', error);
    }
  };

  /**
   * Method to handle handleOpenFailed - overriden by Livechat SDK method
   * @param retCode : Return code sent from livechat SDK based on OpenFailed error.
   */
  handleOpenFailed = (retCode: string) => {
    // console.log('%c handleOpenFailed: ' + retCode, 'color: cyan');
    try {
      this.messengerService.LivechatStatus = 'OpenFailed';
      this.livechatStatus = this.messengerService.LivechatStatus;
      sessionStorage.clear();
      if (retCode === 'NoSessionFound') {
        this.commInterface.accessToken();
        this.commInterface.sessionTokenObservable.subscribe((tokenMsg) => {
          if (tokenMsg.successMsg) {
            this.log('Info', 'handleOpenFailed.GetAccessToken', tokenMsg.successMsg, true);
            $b.SetSessionStorage('token', tokenMsg.successMsg);
            this.isCaptchaLoaded = false;
            // Check if Captcha is Enabled and route to captcha
            if (this.isCaptchaEnabled === true) {
              this.zone.run(() => { 
                this.route.navigate(['captcha'], { queryParamsHandling: 'preserve' }) 
              });
            } else {
              this.startService.checkforLivechatStart(''); // start the service is captcha is disabled
            }
          } else if (tokenMsg.errorMsg) {
            this.log('error', 'handleOpenFailed.GetAccessToken', tokenMsg.errorMsg, true);
          }
        });
      } else if (retCode === 'CookiesDisabled') {
        this.log('error', 'handleOpenFailed', 'Please enable browser cookies', true);
      } else if (retCode === 'AlreadyEndedSession') {
        this.sessionStarted = false;
        sessionStorage.clear(); // remove the sessionstorage on handleOnEnd
        $b.RemoveLocalStorage('appconfig'); // remove the app-config stored in the localstorage
        $b.SetLocalStorage('chatActive', false);
        const navigationExtras: NavigationExtras = {
          queryParamsHandling: 'preserve',
          preserveFragment: true,
          state: { reload: true }
        };
        location.href = location.origin + window.location.pathname.substring(0, window.location.pathname.lastIndexOf('/')) + '?intent=' + this.intent;
        this.zone.run(() => { 
          this.route.navigate(['/'], navigationExtras);
        });
      } else if (retCode === 'RequestFailed') {
        this.snackBar.open(`No Internet Connection`, '', {
          duration: 4000,
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
          panelClass: ['custom-snackbar']
        });
        const timeoutDuration = (this.appConfig?.timeoutDurations?.requestFailed) ? 
        this.appConfig.timeoutDurations.requestFailed : 10000;
        setTimeout(() => {
          this.commInterface.open();
        }, timeoutDuration);
      } else {
        this.sessionStarted = false;
        $b.SetSessionStorage('sessionStarted', false);
      }
      if (this.appConfig.Miscellaneous.OpenStartTimeoutEnabled) {
        setTimeout(() => {
          if ($b.GetSessionStorage('sessionStarted') === null) {
            this.commInterface.end('Session Timed Out', '');
            const navigationExtras: NavigationExtras = {
              queryParamsHandling: 'preserve',
              preserveFragment: true,
              state: { reload: true }
            };

            // [MS: Sep 13, '21] route to custom static page if configured
            if (this.appConfig?.Miscellaneous?.CustomStartPageUrl) {
              location.href = this.appConfig?.Miscellaneous?.CustomStartPageUrl + location.search;
            }
            
            else {
              // Navigate to thank-you page if ThankyoupageEnabled
              if (this.appConfig.Miscellaneous.ThankyoupageEnabled) {
                this.zone.run(() => { 
                  this.route.navigate(['/thank-you'], navigationExtras);
                });
              } else {
                // Navigate to main page if captcha is enabled
                if (this.isCaptchaEnabled === true) {
                  location.href =
                    location.origin + window.location.pathname.substring(0, window.location.pathname.lastIndexOf('/')) + '?intent=' + this.intent;
                    this.zone.run(() => { 
                      this.route.navigate(['/'], navigationExtras);
                    });
                } else {
                  location.href =
                  location.origin + window.location.pathname.substring(0, window.location.pathname.lastIndexOf('/')) + '?intent=' + this.intent;
                  this.zone.run(() => { 
                    this.route.navigate(['/'], navigationExtras);
                  });
                }
                
              }
            }
            this.snackBar.open(`Session was kept Idle, Reconnected..`, '', {
              duration: 3000,
              horizontalPosition: 'center',
              verticalPosition: 'bottom',
              panelClass: ['mat-toolbar']
            });
          }
        }, this.appConfig.Miscellaneous.OpenStartTimeoutDuration);
      }
    } catch (error) {
      console.error('%c Error Occured in handleOpenFailed - ', 'color: red', error);
    }
  };

  /**
   * Method to handle handleStartSuccess - overriden by Livechat SDK method
   */
  handleStartSuccess = (params?: any) => {
    // console.log('%c handleStartSuccess: ', 'color: cyan');
    try {
      this.messengerService.LivechatStatus = 'StartSucess';
      this.livechatStatus = this.messengerService.LivechatStatus;
      this.sessionStarted = true;
      $b.SetSessionStorage('sessionStarted', true);
      this.sessionId = params?.tChatId?.split('_')?.[1];
    } catch (error) {
      console.error('%c Error Occured in handleStartSuccess - ', 'color: red', error);
    }
  };

  /**
   * Method to handle handleInternalServerError - overriden by Livechat SDK method
   * @param errorCode : Error code value sent from livechat incase of Internal Server Error
   */
  handleInternalServerError = (errorCode) => {
    // console.log('%c handleInternalServerError: ' + errorCode, 'color: cyan');
    try {
      this.messengerService.LivechatStatus = 'InternalServerError';
      this.livechatStatus = this.messengerService.LivechatStatus;
      this.snackBar.open(`Internal Server Error - Closing Session`, '', {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'bottom',
        panelClass: ['mat-toolbar']
      });
      this.commInterface.end('Internal Server Error', '');
      if (errorCode === 'UnOpenedSessionNotAllowed') {
        this.reloadandReturn();
      }
    } catch (error) {
      console.error('%c Error Occured in handleInternalServerError - ', 'color: red', error);
    }
  };

  /**
   * Method to handle handleStartFailed - overriden by Livechat SDK method
   * @param code : Code sent from livechat SDK on startfailed.
   */
  handleStartFailed = (code: string) => {
    // console.log('%c handleStartFailed: ' + code, 'color: cyan');
    try {
      this.messengerService.LivechatStatus = 'StartFailed';
      this.livechatStatus = this.messengerService.LivechatStatus;
      if (code === 'AlreadyStartedAndInSession') {
        this.reloadandReturn();
        this.handleStartSuccess(); // continue the session which already exists
      } else if (
        code === 'UnOpenedSessionPerformedStart' ||
        code === 'StartError' ||
        code === 'ServerInternalConnectivityError' ||
        code === 'AlreadyEndedSession'
      ) {
        this.reloadandReturn();
      } /** RequestFailed scenario when network if off, trying to restart the session */ else if (code === 'RequestFailed') {
        this.snackBar.open(`No Internet Connection`, '', {
          duration: 4000,
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
          panelClass: ['custom-snackbar']
        });
        const timeoutDuration = (this.appConfig?.timeoutDurations?.requestFailed) ? 
        this.appConfig.timeoutDurations.requestFailed : 10000;
        setTimeout(() => {
          this.startService.checkforLivechatStart('');
        }, timeoutDuration);
      } else {
        // Check if Captcha is Enabled
        if (this.isCaptchaEnabled === true) {
          this.zone.run(() => { 
            this.route.navigate(['captcha'], { queryParamsHandling: 'preserve' });
          });
        } else {
          this.startService.checkforLivechatStart('');
        }

        // emit the events for subscribers
        this.eventBus.emitEventListeners('SessionStartFailed', { code });
      }
    } catch (error) {
      console.error('%c Error Occured in handleStartFailed - ', 'color: red', error);
    }
  };

  /**
   * Method to handle handleRemoteUserConnected - overriden by Livechat SDK method
   * @param name : Name of the Agent.
   * @param agentId : ID of the Agent.
   * @param sessionID : Session ID of the current Session.
   * @param extraParam : Extra params sent if any for particular Agent.
   */
  handleRemoteUserConnected = (name: string, agentId: string, sessionID: string, extraParam) => {
    // console.log('%c handleRemoteUserConnected: ' + name + '| Agent ID: ' + agentId + '| Session ID: ' + sessionID + '| Param: ' + extraParam, 'color: cyan');
    try {
      this.messengerService.LivechatStatus = 'RemoteUserConnected';
      this.livechatStatus = this.messengerService.LivechatStatus;
      // if the extra parameter is there, then store to session storage for that agent
      if (extraParam) {
        $b.SetSessionStorage('a_' + agentId, extraParam);
      }

      // define the details
      let details = null;

      // get the agent details from the storage or extra params
      const jsonData = $b.GetSessionStorage('a_' + agentId) || (typeof extraParam !== 'undefined' ? extraParam : null);

      // parse the data if available
      details = jsonData ? JSON.parse(jsonData) : null;

      // check if the details available, else handle in legacy way
      if (details && details.agentType) {
        // check the agent type is 'chatbot'
        if (details.agentType === 'Chatbot') {
          // assign the who
          this.who = 'bot';
          console.log('%c handleRemoteUserConnected - Initial connect, This is a bot!', 'color: #f143cc');
          // push the agent to agent list in messenger service
          const botDetail = { type: 'bot', agentId, agentName: name, agentTheme: '' };
          const isAgentAlreadyPresent = this.messengerService.agentList.find(agent =>{
            return agent.agentId == agentId
          });
          if(!isAgentAlreadyPresent){
            this.messengerService.agentList.push(botDetail);
            this.messengerService.handleConferenceUsers(this.messengerService.agentList);

            if(this.appConfig?.chatBot?.enabled) {
                const navigationExtras: NavigationExtras = {
                  queryParamsHandling: 'preserve',
                  queryParams: details,
                  state: { agent: botDetail} 
                };
                this.zone.run(() => { 
                  this.route.navigate(['chat'], navigationExtras); 
                }); 
                // this.eventBus.emitEventListeners(eventName, jsonMessage);             
              }
          }
        }
        // this can be a connect without bot or a connect after bot or after queue so assign to agent
        else if (this.who === '' || this.who === 'bot' || this.who === 'queue') {
          this.who = 'agent';
          console.log('%c handleRemoteUserConnected - Agent connected', 'color: #f143cc');

          this.UserConnectednavigationExtras = {
            queryParamsHandling: 'preserve',
            preserveFragment: true,
            state: { data: name, user: { type: 'agent', agentId, agentName: name, agentTheme: this.defaultFirstAgentTheme } }
          };

          this.existingAgent = this.UserConnectednavigationExtras;

          // update livechat user list
          this.messengerService.userChanged(this.UserConnectednavigationExtras);

          // route to chat component
          this.zone.run(() => { 
            this.route.navigate(['chat'], this.UserConnectednavigationExtras);
          });

          // update the agent list
          if(this.messengerService.agentList.length === 0){
            this.messengerService.agentList.push({ type: 'agent', agentId, agentName: name, agentTheme: '' });
          } else {
            this.messengerService.agentList.map(x => {
              if(x.agentId !== agentId){
                this.messengerService.agentList.push({ type: 'agent', agentId, agentName: name, agentTheme: '' });
              }
            })
          }

          
          this.assignAgentTheme();
          this.messengerService.handleConferenceUsers(this.messengerService.agentList);
        } else {
          // this can be when an agent already connected and conference agent connects
          this.who = 'cAgent';

          console.log('%c handleRemoteUserConnected - Conference agent connected', 'color: #f143cc');

          // push the agent to agent list in messenger service
          if(this.messengerService.agentList.length === 0){
            this.messengerService.agentList.push({ type: 'agent', agentId, agentName: name, agentTheme: '' });
          } else {
            this.messengerService.agentList.map(x => {
              if(x.agentId !== agentId){
                this.messengerService.agentList.push({ type: 'agent', agentId, agentName: name, agentTheme: '' });
              }
            })
          }
          
          this.assignAgentTheme();
          this.messengerService.handleConferenceUsers(this.messengerService.agentList);
        }
        return;
      }

      // set legacy flag to true
      this.legacy = true;

      // push the agent to agent list in messenger service | Following code commented by Varsha 11/11/2021 as a fix for onrefresh chat goes to conference |
      // this.messengerService.agentList.push({ type: 'agent', agentId, agentName: name, agentTheme: '' });
      // this.assignAgentTheme();
      // this.messengerService.handleConferenceUsers(this.messengerService.agentList);

      // check if this is the first agent connect to chat
      // this can be bot/agent in legacy mode
      // we blindly assign the who to 'agent'
      // later if its a bot, the who will be changed to 'bot' in ChatBotStartEvent
      if (this.who === '') {
        console.log('%c handleRemoteUserConnected - Initial connect, This can be a bot too!', 'color: #f143cc');
        this.who = 'agent';
      } else if (this.who === 'bot' || this.who === 'queue') {
        console.log('%c handleRemoteUserConnected - First agent connected', 'color: #f143cc');
        this.who = 'agent';
        const firstMessage = name;
        console.log(firstMessage);
        const navigationExtras: NavigationExtras = {
          queryParamsHandling: 'preserve',
          preserveFragment: true,
          state: { data: firstMessage }
        };

        // update the agent list
        this.messengerService.agentList.push({ type: 'agent', agentId, agentName: name, agentTheme: '' });
        this.assignAgentTheme();
        this.messengerService.handleConferenceUsers(this.messengerService.agentList);
        // update livechat user list

        this.zone.run(() => { 
          this.route.navigate(['chat'], navigationExtras);
        });
        
      } else {
        // this can be when an agent already connected and conference agent connects
        this.who = 'cAgent';
        console.log('%c handleRemoteUserConnected - Conference agent connected', 'color: #f143cc');
      }
    } catch (error) {
      console.error('%c Error Occured in handleRemoteUserConnected - ', 'color: red', error);
    }
  };

  /**
   * Method to handle handleConferenceUserLeft - overriden from Livechat SDK methods
   * @param agent : Agent ID who has left the conference.
   * @param reason : Reason due to which Agent has left.
   */
  handleConferenceUserLeft = (agent: string, reason: string) => {
    // console.log('%c handleConferenceUserLeft : Agent' + agent + '| Reason : ' + reason, 'color: cyan');
    try {
      this.messengerService.LivechatStatus = 'ConferenceUserLeft';
      this.livechatStatus = this.messengerService.LivechatStatus;
      // get all the connected agent list
      let connectedAgents = this.messengerService.agentList;

      // initially set who as conference agent
      let who = 'cAgent';
      // get the disconnected agent name from the list by agentid filter
      const AgentName = connectedAgents.filter((a) => a.agentId === agent)[0].agentName;
      // get the disconnected agent type from the list by agentid filter
      const Type = connectedAgents.filter((a) => a.agentId === agent)[0].type;

      const disconnectedAgent = { agentID: agent, agentName: AgentName, type: Type };
      // TODO:: show agent left message in livechat
      this.messengerService.handleConnectedUserLeft(disconnectedAgent);
      if (Type === 'agent') {
        this.snackBar.open(`${AgentName} has left !!`, '', {
          duration: 3000,
          horizontalPosition: 'center',
          verticalPosition: 'bottom'
        });
      }

      // remove the disconnected agent from the list
      connectedAgents = connectedAgents.filter((a) => a.agentId !== agent);
      if (connectedAgents && connectedAgents.length <= 2) {
        // if the bot is disconnected after agent transfer and if agent do a blind transfer to queue
        // there will be no agent connected at that time give last agent name as header label and who as queue
        if (connectedAgents.length === 0) {
          who = 'queue';
          // if there are 3 agents including bot, then if an agent leave then change the header label and who reference
          // else let it header label as 'Conference' and who as 'cAgent' only
        } else {
          // set the 'who' as type of last connected agent
          who = connectedAgents[connectedAgents.length - 1].type;
        }
      }
      // assign the who
      this.who = who;
      // update the agent list
      this.messengerService.agentList = connectedAgents;
      setTimeout(() => {
        this.messengerService.handleConferenceUsers(this.messengerService.agentList);
      }, 1000);
      // remove the agent details from the session storage
      $b.RemoveSessionStorage('a_' + agent);
    } catch (error) {
      console.error('%c Error Occured in handleConferenceUserLeft - ', 'color: red', error);
    }
  };

  /**
   * Method to handle handleCallbackAutoRegistered coming from livechat SDK
   * @param reasonCode : Reason code for CallBackAutoRegistered.
   */
  handleCallbackAutoRegistered = (reasonCode: string) => {
    // console.log('%c handleCallbackAutoRegistered :', reasonCode,'color: cyan');
    try {
      this.commInterface.end(`Callback AutoRegistered : ${reasonCode} `, '');
      this.reloadandReturn();
    } catch (error) {
      console.error('%c Error Occured in handleCallbackAutoRegistered - ', 'color: red', error);
    }
  };

  /**
   * Method to handle handleTypingStateChanged coming from livechat SDK
   * @param agent : Agent ID/Name who is typing
   * @param stat : Typing status of the Agent
   */
  handleTypingStateChanged = (agent: string, state: number) => {
    // console.log('%c Typing Agent: ', +agent + 'Stat' + state, 'color: cyan');
    try {
      this.messengerService.sendAgentTypingStatus({ agent, state });
    } catch (error) {
      console.error('%c Error Occured in handleTypingStateChanged - ', 'color: red', error);
    }
  };

  // handleNotifyTypingStateChanged = (state: any) => {
  //   console.log('Typing State: ',  + state);
  // }

  /**
   * Method to handle AppMessageEvent coming from livechat SDK
   * @param agent : Agent Name / ID
   * @param message : App message being sent from TMAC/AD as JSON string
   * @param id : App Message ID
   */
  handleAppMessageEvent = (agent: string, message: string, id: string) => {
    // console.log('%c handleAppMessageEvent : Agent' + agent + '| Message : ' + message + '| ID : ' + id, 'color: cyan');
    try {
      const appmessage = JSON.parse(message);
      if (appmessage.type === 'conferenceConnected') {
        this.handleRemoteUserConnected(appmessage.data.agentName, appmessage.data.agentId, '', '');
      } else if (appmessage.type === 'conferenceDisconnected') {
        this.handleConferenceUserLeft(appmessage.data.agentId, '');
      }
      this.messengerService.LivechatStatus = 'AppMessageRecieved';
      this.livechatStatus = this.messengerService.LivechatStatus;
      console.log('AppMessage: ', { agent, id, message });
      this.messengerService.appMessageReceived({ agent, id, message });
    } catch (error) {
      console.error('%c Error Occured in handleAppMessageEvent - ', 'color: red', error);
    }
  };

  /**
   * Method to handle OnMessageReceived Event
   * @param agent : Agent Name / ID or Bot
   * @param message : ChatBot messages
   * @param id : Message Received Event ID
   */
  handleMessageReceivedEvent = (agent: string, message: string, id: string) => {
    // console.log('%c handleMessageReceivedEvent : Agent' + agent + '| Message : ' + message + '| ID : ' + id, 'color: cyan');
    this.messengerService.LivechatStatus = 'OnMessageReceived';
    this.livechatStatus = this.messengerService.LivechatStatus;
    // console.log("Agent: " + agent + "| Message: " + message + "| ID : " + id);
    try {
      const chatRefreshCondition = $b.IsValidJson(message) && !$b.JParse(message).messageId && agent !== 'c';
      // console.log('AppComponent: Message Recieved - Agent: ' + agent + 'Message : ' + message + 'ID : ' + id);
      // bot messages are always JSON message in OnMessageReceived event
      if ((!this.legacy && this.who === 'bot') || (this.legacy && $b.IsValidJson(message) && chatRefreshCondition)) {
        // parse the json message using browser util reference
        const jsonMessage = $b.JParse(message);

        try {
          console.log(jsonMessage);
          let methodName = jsonMessage?.EventName;
          if (this[methodName]) {
            this.commInterface.logToServer(
              'info',
              'AppComponent.handleMessageReceivedEvent',
              `Method name: ${methodName}`
            );
            switch (methodName) {
              case 'ChatBotActionEvent':
                if(jsonMessage?.Action !== 'QPOS')this[methodName](jsonMessage);
                break;
              default:
                this[jsonMessage.EventName](agent, jsonMessage, 'new', false);
                break;
            }
          }
        } catch (error) {
          console.error('%c Error Occured in handleMessageReceivedEvent.methodName', 'color: red', error);
          this.commInterface.logToServer(
            'error',
            'Error occured in AppComponent.handleMessageReceivedEvent.methodName',
            JSON.stringify(error)
          );
        }
        // check if NodeType present in the event
        if (jsonMessage?.NodeType) {
          let eventName = 'MessageEvent';
          let url = '';
          let state = { data: JSON.stringify(jsonMessage), headerFooter: '' };
          switch (jsonMessage.NodeType) {
            case 'HF':
              eventName = 'HeaderFooterEvent';
              $b.SetSessionStorage('headerFooter', JSON.stringify(jsonMessage));
              $b.SetSessionStorage('SessionId', jsonMessage.SessionId);
              break;
            case 'PROMPT':
              eventName = 'AnnouncementEvent';
              url = 'announcement';
              break;
            case 'MENU':
              eventName = 'MenuEvent';
              url = 'menu';
              state = { data: JSON.stringify(jsonMessage), headerFooter: $b.GetSessionStorage('headerFooter') };
              break;
            case 'FORM':
              eventName = 'FormEvent';
              url = 'forms';
              break;
            case 'PNC':
              eventName = 'PNCEvent';
              url = 'pnc';
              break;
            case 'ACTION':
              eventName = 'ActionEvent';

              if (jsonMessage.EventName === 'QueuePosition') {
                this.queueService.updateQueueNumberandImage(
                  jsonMessage?.Text,
                  jsonMessage?.Image,
                  jsonMessage?.OtherData,
                  jsonMessage?.AgentTransferText
                );
              } else if (jsonMessage.EventName === 'ChatBotActionEvent') {
                  this.ChatBotActionEvent(jsonMessage);
              }
              // url = "chatqueue";
              break;
            default:
              eventName = 'MessageEvent';
              console.log(jsonMessage);
              break;
          }
          // if url is there and chatbot not enabled then route
          if (url && !(this.appConfig?.chatBot?.enabled) ) {
            // navigate to url
            // this.route.navigateByUrl('/' + url);
            const navigationExtras: NavigationExtras = {
              queryParamsHandling: 'preserve',
              preserveFragment: true,
              state
            };
            this.zone.run(() => { 
              this.route.navigate([url], navigationExtras); 
            }); // navigate to different pages based on nodeType match
          }

          // if chatbot enabled and message is from a valid node then process the message
          if(this.appConfig?.chatBot?.enabled && jsonMessage.NodeType !== 'HF' && jsonMessage.NodeType !== 'ACTION' && jsonMessage.EventName !== 'QueuePosition' && jsonMessage.NodeType !== 'ChatbotSelfServiceEndedEvent') {
            this.messengerService.setActiveNode(jsonMessage);
            this.generateMessageToProcess(jsonMessage, agent);
          }
          // emit the events for subscribers
          this.eventBus.emitEventListeners(eventName, jsonMessage);
        }
        // following condition added to process customer selected / submitted msgs with bot when browser refreshed
        if (agent === 'c' && this.appConfig?.chatBot?.enabled && $b.GetSessionStorage('Initial Load') > 1 && jsonMessage.NodeType !== 'ACTION') {
          const jsonMessage = $b.JParse(message);
          this.generateMessageToProcess(jsonMessage, agent);
        }
      }
      // else its an agent message
      else if (this.who === 'agent' || this.who === 'cAgent') {
        const jsonMessage = $b.JParse(message);
        if(jsonMessage.NodeType !== 'ACTION')
        this.handleAgentMessages(agent, message, id, 'new', false);
      } else if (agent === 'c' && this.appConfig?.chatBot?.enabled && $b.GetSessionStorage('Initial Load') > 1) {
        const jsonMessage = $b.JParse(message);
        if(jsonMessage.NodeType !== 'ACTION') this.generateMessageToProcess(jsonMessage, agent);
      }
    } catch (error) {
      console.error('%c Error Occured in handleMessageReceivedEvent - ', 'color: red', error);
    }
  };

  /**
   * Method to handle Agent messages from livechat
   * @param agent : Agent details
   * @param message : Message text
   * @param id : ID for individual message
   * @param messagetype : Agent Message Type
   * @param status : Message Status
   */
  handleAgentMessages = (agent, message, id, messagetype, status) => {
    try {
      // console.log('%c HandleAgentMessages : Agent' + agent + '| ID : ' + id + '| Message : ' + message + '| Message Type : ' + messagetype + '| Status : ' + status, 'color: cyan');
      this.messengerService.LivechatStatus = 'AgentMessageRecieved';
      this.livechatStatus = this.messengerService.LivechatStatus;
      this.initialMsgIndex++;
      const msgBy = this.messengerService.agentList.filter((a) => a.agentId === agent)[0];
      let AgentTheme;
      if (msgBy === undefined) {
        AgentTheme = '#ffffff';
      } else {
        AgentTheme = msgBy.agentTheme;
      }
      const msg = { message, by: { id: agent, name: msgBy ? msgBy.agentName : agent === 'c' ? 'You' : this.getSenderName(), agentTheme: AgentTheme } };
      if (this.initialMsgIndex === 1) {
        $b.SetSessionStorage('initialMsg', JSON.stringify(msg));
      }
      
      // this should be monitored 
      if(this.appConfig?.chatBot?.enabled) {
        setTimeout((m) => {          
          this.messengerService.agentMessageReceived(m);
        }, 1000, msg);
      } else {
          this.messengerService.agentMessageReceived(msg);
      }
      
      
    } catch (error) {
      console.error('%c Error Occured in handleAgentMessages - ', 'color: red', error);
    }
  };

  /**
   * 
   * @returns name of the deafult sender when the type of sender is agent
   */
  getSenderName() {
    if(this.appConfig?.chatBot?.enabled) {
      return 'Tetherfi'; // this should be made configurable
    } else {
      return '';
    }
  }

  /**
   * Handle livechat echo messages
   * @param message : Echo Message
   * @param id : ID of the Agent
   */
  handleEchoMessages = (message: string, id: string) => {};

  /**
   * Method to handle livechat OnEnd event
   * @param initiator : Customer/Agent
   * @param reason : Reason to end the call
   */
  handleOnEnd = (initiator: string, reason: string) => {
    try {
      // console.log('%c handleOnEnd: ' + initiator + ' - ' + reason, 'color: cyan');
      this.messengerService.LivechatStatus = 'OnEnd';
      this.livechatStatus = this.messengerService.LivechatStatus;
      if (initiator === 'lib' && reason === 'SessionLostWhileOffline') {
        this.snackBar.open(`Session Lost, Connecting again...`, '', {
          duration: 3000,
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
          panelClass: ['mat-toolbar']
        });
      }
      this.onEndRedirection(initiator);
    } catch (error) {
      console.error('%c Error Occured in handleOnEnd - ', 'color: red', error);
    }
  };

  onEndRedirection = (initiator?) => {
    try {
      this.sessionStarted = false;
      sessionStorage.clear(); // remove the sessionstorage on handleOnEnd
      $b.RemoveLocalStorage('appconfig'); // remove the app-config stored in the localstorage
      $b.SetLocalStorage('chatActive', false);
      $b.SetLocalStorage('postInteractionSurvey', false);
      this.resetLocalStorage();
      this.commInterface.notifyEndOfSession(initiator);      

      if(!(this.appConfig?.disableRedirectionOnEnd) || initiator === 'client') {
        setTimeout(() => {
          const navigationExtras: NavigationExtras = {
            queryParamsHandling: 'preserve',
            preserveFragment: true,
            state: { reload: true }
          };
  
          // [MS: Sep 13, '21] route to custom static page if configured
          if (this.appConfig?.Miscellaneous?.CustomStartPageUrl) {
            location.href = this.appConfig?.Miscellaneous?.CustomStartPageUrl + location.search;
          } else {     
            // Navigate to thank-you page if ThankyoupageEnabled     
            if (this.appConfig.Miscellaneous.ThankyoupageEnabled) {
              this.zone.run(() => { 
                this.route.navigate(['/thank-you'], navigationExtras);
              });
            } else {            
              // Navigate to main page if captcha is enabled
              if (this.isCaptchaEnabled === true) {
                location.href = location.origin + window.location.pathname.substring(0, window.location.pathname.lastIndexOf('/')) + '?intent=' + this.intent;
                this.zone.run(() => { 
                  this.route.navigate(['/'], navigationExtras);
                });
              } else {
                location.href =
                location.origin + window.location.pathname.substring(0, window.location.pathname.lastIndexOf('/')) + '?intent=' + this.intent;
                this.zone.run(() => { 
                  this.route.navigate(['/'], navigationExtras);
                });
              }            
            }
          }
        }, 1000);
      }
      
    } catch (error) {
      console.error('%c Error Occured in Ending session and redirection - ', 'color: red', error);
    }
  };

  handleCallQueued = (queuePos: number, queueType: string) => {

    /** availableQueueTypes : is a string of comma seperated values
     * Get available queue types from configuration to allow to process through queue 
     */
    let availableQueueTypes = this.appConfig?.ChatQueueComponent?.availableQueueTypes;
    availableQueueTypes = availableQueueTypes ? availableQueueTypes.split(',') : ['2','3'];
    
    try {
      // console.log('%c Inside Handlecallqueued: ' + queuePos + ' - ' + queueType, 'color: cyan');
      this.messengerService.LivechatStatus = 'OnCallQueued';
      if (queuePos && queuePos > 0 && queueType && availableQueueTypes.includes(queueType)) {
        // queue position for liveagent
      }

      if (availableQueueTypes.includes(queueType)) {
        this.queueService.queuePos = queuePos;
        const navigationExtras: NavigationExtras = {
          queryParamsHandling: 'preserve',
          preserveFragment: true
        };

        // route to chat queue component if chatbot feature is disabled
        if(this.appConfig?.chatBot?.enabled) {
          this.commInterface.inQueue.next(queuePos);
        } else {
          this.zone.run(() => { 
            this.route.navigate(['chatqueue'], navigationExtras);
          });
        }       
      }
    } catch (error) {
      console.error('%c Error Occured in handleCallQueued - ', 'color: red', error);
    }
  };

  /**
   * Handled ServerStateChanged when internet goes off or connection drops, calling livechat.Open() to indicate the `RequestFailed` message.
   */
  handleServerStateChanged = () => {
    let serverStateCount:number = $b.GetLocalStorage('serverStateChangeCount');
    if(serverStateCount !== null) {
      $b.SetLocalStorage('serverStateChangeCount', ++serverStateCount);  
      this.getOnlineStatus(serverStateCount) ? this.showAsOnline(): '';   
    } else {
      const offlineDateTime = new Date(Date.now());
      this.manageOfflineLogging('Connection between UI and Proxy lost - No Internet', offlineDateTime);
      $b.SetLocalStorage('serverStateChangeCount', 1);
    }
    this.commInterface.open();
  };

  getOnlineStatus(statusChangedCount) {
    return statusChangedCount%2 === 0 ? true : false;
  }

  manageOfflineLogging = (data, time) => {
    const log = {
      message: data,
      offlineTime: time.toString()
    }
    const logArray = [];
    logArray.push(JSON.stringify(log));
    $b.SetLocalStorage('Offline Log', logArray);
  }

  showAsOnline() {
    this.snackBar.open(`Back to online`, '', {
      duration: 3000,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: ['success-snackbar']
    });
    const offlineLogs = JSON.parse($b.GetLocalStorage('Offline Log'));
    this.commInterface.logToServer('error', `${offlineLogs.message}`, offlineLogs.offlineTime);
    this.commInterface.sendAppMessage(JSON.stringify(offlineLogs));
    const onlineDateTime = new Date(Date.now());
    this.commInterface.logToServer('error', 'Connection between UI and Proxy - Back Online', onlineDateTime.toString());
    const onlineLog = {
      message: 'Connection between UI and Proxy - Back Online',
      offlineTime: onlineDateTime.toString()
    }
    this.commInterface.sendAppMessage(JSON.stringify(onlineLog));
  }

  /*------------------------------------------- Start of TPPVA Events -----------------------------------------------*/

  /**
   * Method to handle TPPVA ChatBotChatStartEvent event
   */
  ChatBotChatStartEvent = (agentId: any, event: any, type: any, islast: any) => {
    this.log('info', 'ChatBotChatStartEvent', 'Ignore this event', true);
    this.who = 'bot';
    this.resetLocalStorage();
    // this.messengerService.agentList = [];
    // this.messengerService.agentList.push({ type: 'bot', agentId, agentName: '',agentTheme: ''});
  };

  /**
   * Method to handle TPPVA ChatBotMessageEvent event
   */
  ChatBotMessageEvent = (agentId: any, event: any, type: any, isLast: any) => {
    // this.log('info', 'ChatBotMessageEvent', event, true);
  };

  /**
   * Method to handle TPPVA ChatBotOnModuleEvent event
   */
  ChatBotOnModuleEvent = () => {
    this.log('info', 'ChatBotOnModuleEvent', 'Ignore this event', true);
  };

  /**
   * Method to handle TPPVA ChatBotQueuedEvent event
   */
  ChatBotQueuedEvent = () => {
    this.log('info', 'ChatBotQueuedEvent', 'Ignore this event', true);
  };

  /**
   * Method to handle TPPVA ChatBotActionEvent event
   */
  ChatBotActionEvent = (message) => {
    try {
      this.log('info', 'ChatBotActionEvent', message?.Action, true);
      switch (message?.Action) {
        case 'INVOKEFUNCTION':
          this.invokeCustomFunction(message);
          break;
        case 'URLPOP':
          if (this.appConfig?.Miscellaneous?.confirmationOnUrlPop) {
            this.confirmDialog(
              (
                this.appLabels?.globalLabels?.urlPopRedirectWarn ??
                `Visual IVR is trying to navigate to **url**. Do you wish to continue?`
              ).replace('**url**', message.Text),
              '',
              (result) => {
                if (result) window.open(message.Text, '_blank');
              }
            );
          } else window.open(message.Text, '_blank');
          break;
        case 'ShowQueuePop':
          this.queueService.toggleQueueOverlay(true);
          break;
        case 'HideQueuePop':
          this.queueService.toggleQueueOverlay(false);
          break;
        case 'PlayQueueVideo':
          this.queueService.queueVideo = message.Text;
          this.queueService.updateQueueVideo.next(message);
          break;
        case 'QPOS':
          this.queueService.updateQueuePostionText(message.Text);
          break;
      }
    } catch (error) {
      console.error('%c Error Occured in ChatBotActionEvent', 'color: red', error);
      this.commInterface.logToServer(
        'error',
        'Error occured in AppComponent.ChatBotActionEvent',
        JSON.stringify(error)
      );
    }
  };

  /**
   * Method to invoke the custom function in customScript.js file
   * @param message : Action Node data
   */
  invokeCustomFunction(message: any) {
    try {
      const functionName: string = message?.Text?.split(':')[0];
      const functionParametersArray: string[] = message?.Text?.split(':')[1].split(',');
      let functionArgumentsArray: any[] = [];

      if (functionParametersArray.length) {
        functionParametersArray.forEach((parameter: string) => {
          if (parameter.includes('$')) {
            switch (parameter.trim().toLowerCase().replace('$', '')) {
              case 'sessionid':
                functionArgumentsArray.push($b.GetSessionStorage('SessionId'));
                break;
              case 'interactionid':
                functionArgumentsArray.push(this.interactionID);
                break;
              case 'agentdata':
                functionArgumentsArray.push(JSON.stringify(this.messengerService.agentList));
                break;
              default:
                break;
            }
          }
        });
      }
      this.commInterface.logToServer(
        'info',
        'AppComponent.invokeCustomFunction',
        `functionName: ${functionName}, functionArguments: ${JSON.stringify(functionArgumentsArray)}`
      );
      if (window.customFunction[functionName]) window.customFunction[functionName](...functionArgumentsArray);
    } catch (error) {
      console.error('%c Error Occured in invokeCustomFunction', 'color: red', error);
      this.commInterface.logToServer(
        'error',
        'Error occured in AppComponent.invokeCustomFunction',
        JSON.stringify(error)
      );
    }
  }

  /**
   * Method to handle TPPVA ChatBotComponentEvent event
   */
  ChatBotComponentEvent = (agentId: any, event: any, type: any, isLast: any) => {
    this.log('info', 'ChatBotComponentEvent', 'received', true);
  };

  /**
   * Method to handle TPPVA ChatBotFormEvent event
   */
  ChatBotFormEvent = (agentId: any, event: any, type: any, isLast: any) => {
    this.log('info', 'ChatBotFormEvent', 'received', true);
  };

  /**
   * Method to handle TPPVA ChatBotHFEvent event
   */
  ChatBotHFEvent = (agentId: any, event: any, type: any, isLast: any) => {
    this.log('info', 'ChatBotHFEvent', 'received', true);
  };

  /**
   * Method to handle TPPVA ChatbotSelfServiceEndedEvent event
   */
  ChatbotSelfServiceEndedEvent = () => {
    this.log('info', 'ChatbotSelfServiceEndedEvent', 'received', true);
    if (this.appConfig.Miscellaneous.ChatbotSelfServiceEndedRoutingEnabled) {
      this.zone.run(() => { 
        this.route.navigate(['chat'], this.UserConnectednavigationExtras);
      });
    }
  };

  /*----------------------------------------- End of TPPVA Events -------------------------------------------------*/

  /**
   * Method to handle signature request from agent
   */
  MediaMessageEvent = () => {
    this.messengerService.requestUserSignature();
  };

  ActionMessageEvent = () => {};

  /**
   * Method to generate random color from the given list of color codes
   */
  generateRandomColor() {
    const selectedColor = this.colorCodes[Math.floor(Math.random() * this.colorCodes.length)];
    const index = this.colorCodes.indexOf(selectedColor);
    if (index > -1) {
      this.colorCodes.splice(index, 1);
    }
    return selectedColor;
  }

  /**
   * Assign random theme color to different agents
   */
  assignAgentTheme = () => {
    if (this.messengerService.agentList.length === 1) {
      this.messengerService.agentList[0].agentTheme = this.defaultFirstAgentTheme;
    } else if (this.messengerService.agentList.length === 2) {
      this.messengerService.agentList[0].agentTheme = this.defaultFirstAgentTheme;
      this.messengerService.agentList[1].agentTheme = this.generateRandomColor();
    } else if (this.messengerService.agentList.length === 3) {
      this.messengerService.agentList[0].agentTheme = this.defaultFirstAgentTheme;
      this.messengerService.agentList[1].agentTheme = this.generateRandomColor();
      this.messengerService.agentList[2].agentTheme = this.generateRandomColor();
    }
  };

  /**
   * Service worker feature to check for updates
   */
  checkForUpdate() {
    if (this.swupdate.isEnabled) {
      this.swupdate
        .checkForUpdate()
        .then(() => {
          console.log('Checking for updates...');
        })
        .catch((err) => {
          console.error('Error when checking for update', err);
        });
    }
  }

  /**
   * Service worker updating the build to latest
   */
  updateToLatest(): void {
    console.log('Updating to latest version.');
    this.swupdate.activateUpdate().then(() => document.location.reload());
  }

  reloadandReturn = () => {
    try {
      const navigationExtras: NavigationExtras = {
        queryParamsHandling: 'preserve',
        preserveFragment: true,
        state: { reload: true }
      };

      // [MS: Sep 13, '21] route to custom static page if configured
      if (this.appConfig?.Miscellaneous?.CustomStartPageUrl) {
        location.href = this.appConfig?.Miscellaneous?.CustomStartPageUrl + location.search;
      }
      else {
        // Navigate to thank-you page if captcha is not enabled
        if (this.appConfig?.Miscellaneous?.ThankyoupageEnabled) {
          this.zone.run(() => { 
            this.route.navigate(['/thank-you'], navigationExtras);
          });
        } else {
          // Navigate to main page if captcha is enabled
          if (this.isCaptchaEnabled === true) {
            location.href = location.origin + window.location.pathname.substring(0, window.location.pathname.lastIndexOf('/')) + '?intent=' + this.intent;
            this.zone.run(() => { 
              this.route.navigate(['/'], navigationExtras);
            });
          } else {
            location.href = location.origin + window.location.pathname.substring(0, window.location.pathname.lastIndexOf('/')) + '?intent=' + this.intent;
            this.zone.run(() => { 
              this.route.navigate(['/'], navigationExtras);
            });
          }
          
        }
      }
    } catch (error) {
      console.error('%c Error Occured in reloadandReturn - ', 'color: red', error);
    }
  };
  /**
   * Method to handle confirm using Matdialog for user acceptance/rejection
   * @param title : Title for the dialog data
   * @param message : message for the dialog component
   * @param onClose : onclose event trigger
   */
  confirmDialog(title: string, message: string, onClose): void {
    try {
      const dialogData = new ConfirmDialogModel(title, message);
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        maxWidth: '400px',
        data: dialogData
      });
      dialogRef.afterClosed().subscribe((dialogResult) => {
        onClose(dialogResult);
      });
    } catch (error) {
      console.error('%c Error Occured in confirmDialog - ', 'color: red', error);
    }
  }

  /**
   * Method to handle events from websocket when websocket is enabled
   * receive data received from websocket service by subscribing to observable
   */
  websocketEvent = () => {
    this.websocketService.socket$.asObservable().subscribe({
      next: (dataFromServer) => {
        try {
          this.parsedData = $b.IsValidJson(dataFromServer) && JSON.parse(dataFromServer);
          console.log(this.parsedData);

          if (this.parsedData.InteractionID === null || this.parsedData.InteractionID === '') {
          } else if (this.parsedData.InteractionID) {
            this.interactionID = this.parsedData.InteractionID; // get local interactionID
            this.websocketService.interactionID = this.parsedData.InteractionID; // update websocket service interactionID
            $b.SetSessionStorage('websocketInteractionID', this.parsedData.InteractionID);
          }

          //calling KeepAlive trigger to keep connection open
          this.keepAliveWebsocket();

          // match with each event and handle different event types
          switch (this.parsedData.EventName) {
            case 'ChatBotChatStartEvent':
              console.log('ChatBotChatStartEvent Triggered');
              this.ChatBotChatStartEvent('', dataFromServer, '', '');
              break;
            case 'ChatBotHFEvent':
              console.log('ChatBotHFEvent Triggered');
              this.ChatBotHFEvent('', dataFromServer, '', '');
              break;
            case 'ChatBotMessageEvent':
              console.log('ChatBotMessageEvent Triggered');
              this.handleMessageReceivedEvent('', dataFromServer, '');
              break;
            case 'ChatBotFormEvent':
              console.log('ChatBotFormEvent Triggered');
              this.handleMessageReceivedEvent('', dataFromServer, '');
              break;
            case 'InteractionClosedEvent':
              console.log('InteractionClosedEvent Triggered');
              this.websocketService.afterRemoteInteractionEnds();
              break;
            case 'KeepAliveAckEvent' : 
              console.log('KeepAliveAckEvent Triggered');
            default:
              break;
          }
        } catch (error) {
          console.error('%c Error Occured in capturing websocketEvent - ', 'color: red', error);
        }
      },
      error: (error) => {
        this.websocketService.socket$.error({code: 4000, reason: `${error}`});
      },
      complete: () => {
        this.websocketService.endWebSocket(this.websocketService.interactionID);
        const navigationExtras: NavigationExtras = {
          queryParamsHandling: 'preserve',
          preserveFragment: true,
          state: { reload: true }
        };

        // [MS: Sep 13, '21] route to custom static page if configured
        if (this.appConfig?.Miscellaneous?.CustomStartPageUrl) {
          location.href = this.appConfig?.Miscellaneous?.CustomStartPageUrl + location.search;
        } else if (this.appConfig.Miscellaneous.ThankyoupageEnabled) {
          this.zone.run(() => { 
            this.route.navigate(['/thank-you'], navigationExtras);
          });
        } else {
          this.zone.run(() => { 
            this.route.navigate(['/'], navigationExtras);
          });
        }
      }
    });
  };

  keepAliveWebsocket = () => {
    const data = {
      Command: 'ping',
      Data: '',
      InteractionId: this.websocketService.interactionID
    }
    setTimeout(() => {
      this.websocketService.sendMessage(data);
    }, 3000);
    // 
  }

  livechat2ReceivedMessages = () => {
    this.commInterface.chatBotReceivedMessage.subscribe((x) => {
      try {
        if (typeof x === 'string') {
          const eventData = JSON.parse(x);
          console.log('%c Event Data : ', 'color:white; background: blue;', eventData);
          if (eventData.InteractionId === null || eventData.InteractionId === '') {
          } else if (eventData.InteractionId) {
            this.interactionID = eventData.InteractionId; // get local interactionID
            this.commInterface.interactionID = eventData.InteractionId; // update websocket service interactionID
            $b.SetSessionStorage('livechat2InteractionID', eventData.InteractionId);
          }
          this.parseChatBotEvents(eventData.EventName, x);
        }
      } catch (error) {
        console.error('%c Error Occured in livechat2ReceivedMessages - ', 'color: red', error);
      }
    });
  };

  parseChatBotEvents = (eventName, chatBotData) => {
    try {
      switch (eventName) {
        case 'ChatBotChatStartEvent':
          console.log('ChatBotChatStartEvent Triggered');
          this.ChatBotChatStartEvent('', chatBotData, '', '');
          break;
        case 'ChatBotHFEvent':
          console.log('ChatBotHFEvent Triggered');
          this.ChatBotHFEvent('', chatBotData, '', '');
          break;
        case 'ChatBotMessageEvent':
          console.log('ChatBotMessageEvent Triggered');
          this.handleMessageReceivedEvent('', chatBotData, '');
          break;
        case 'ChatBotFormEvent':
          console.log('ChatBotFormEvent Triggered');
          this.handleMessageReceivedEvent('', chatBotData, '');
          break;
        case 'InteractionClosedEvent':
          console.log('InteractionClosedEvent Triggered');
          this.websocketService.afterRemoteInteractionEnds();
          break;
        default:
          break;
      }
    } catch (error) {
      console.error('%c Error Occured in parsing Chatbot events - ', 'color: red', error);
    }
  };

  /**
   * Function to create a MatDialog and attach the DevicePermissionsComponent
   * and receive its response once the MatDialog is closed.
   */
   getDevicePermissions = () => {
    const dialogRef = this.dialog.open(DevicePermissionsComponent, {
      panelClass: 'dialog-responsive',
      disableClose: true
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);      
    });
  };

  /** Here we process 2 messages from a node detail 
   * 1. Title text [which will be sent just like a plain agent message]
   * 2. Node detail to inject respective modules as a message layout
   * @param messageDetails contains whole node details 
   * @param agentDetail bot agent detail
   */
  generateMessageToProcess(messageDetails, agentDetail) {
    const message = {
      messageId: '',
      type: 'text',
      message:messageDetails.Text ? messageDetails.Text : messageDetails.Response,
      replyId:'',
      templateId:'',
      attachment: null,
    };    
    const agent = agentDetail;
    if(messageDetails.NodeType !== 'PROMPT') {
      this.handleAgentMessages(agent, JSON.stringify(message), agent.id, 'new', false); 
    }
    if(agent !== 'c') {
      message['type'] = 'bot-layout';
      message['messageId'] = messageDetails.MessageId && messageDetails.MessageId !== '' ? messageDetails.MessageId : messageDetails.EventId;
      message['componentId'] = messageDetails.NodeType;
      message['message'] = '';
      message['nodeDetails'] = {
        ...{
          messageId: message.messageId
        }, ...messageDetails
      };
      this.handleAgentMessages(agent, JSON.stringify(message), agent.id, 'new', false);
    }        
  }

  checkBrowserSupport = () => {
    const browser = Bowser.getParser(window.navigator.userAgent);
    const isValidBrowser = browser.satisfies({...this.browserOptions});
    this.isBrowserValid = isValidBrowser;
    console.log('Browser Validity - ',isValidBrowser);
    console.log(browser.getBrowser());
  }

  /**
   * Resetting the storage on session disconnection 
   */
  resetLocalStorage = () => {
    localStorage.removeItem('inQueue');
  }

  setAppVersion() {
    this.appVersion = this.appDataService.getAppVersion();
    console.log('%c App Version - ' + this.appVersion, 'color:black; background: yellow;');
    this.commInterface.logToServer('info', 'AppComponent.SetAppVersion', 'VIVR-Version:'+this.appVersion);
  }
}
